<template>
  <v-card>
    <div class="text-xs-center">
      <h1 class="text-pagename">Set price/round</h1>
      กำหนดค่าส่งให้กับไรเดอร์ในแต่ละรอบ ในการรับออเดอร์ Free Delivery
    </div>
    <v-form ref="form" v-model="valid">
      <v-layout row wrap justify-center class="mt-3 pa-3">
        <v-flex xs12 sm4 class="pr-3">
          <v-text-field
            label="Insert Price/Round"
            v-model="price_per_round"
            mask="#####"
            :disabled="isEditPriceRound"
            :rules="[(v) => !!v || 'Required']"
          >
          </v-text-field>
        </v-flex>

        <v-flex xs12 sm4 class="pr-3">
          <v-text-field
            label="Insert Distance/Round (m.)"
            v-model="round_distance"
            mask="#####"
            :disabled="isEditPriceRound"
            :rules="[(v) => !!v || 'Required']"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm2 class="pr-3 text-xs-center">
          <v-btn
            color="primary"
            class="black--text"
            :disabled="saving_price || isEditPriceRound"
            :loading="saving_price"
            @click="save()"
            >Save</v-btn
          >
        </v-flex>
      </v-layout>
    </v-form>
    <v-card-text>
      <h3 class="mb-3">Price/round history</h3>

      <v-data-table
        :loading="fetching_data"
        :headers="headers"
        :items="free_price_per_round_list"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td
            :class="
              props.index == 0 ? 'text-xs-center text-bold' : 'text-xs-center'
            "
          >
            {{ props.item.no }}
          </td>
          <td
            :class="
              props.index == 0 ? 'text-xs-center text-bold' : 'text-xs-center'
            "
          >
            {{ parseFloat(props.item.round_price).toFixed(2) }}
          </td>
          <td
            :class="
              props.index == 0 ? 'text-xs-center text-bold' : 'text-xs-center'
            "
          >
            {{ props.item.round_distance }} m.
          </td>
          <td
            :class="
              props.index == 0 ? 'text-xs-center text-bold' : 'text-xs-center'
            "
          >
            {{
              typeof props.item.round_time_start == "string"
                ? props.item.round_time_start.substring(0, 10)
                : props.item.round_time_start
            }}
          </td>
          <td
            :class="
              props.index == 0 ? 'text-xs-center text-bold' : 'text-xs-center'
            "
          >
            {{
              props.item.round_time_end &&
              typeof props.item.round_time_end == "string"
                ? props.item.round_time_end.substring(0, 10)
                : "Present"
            }}
          </td>
        </template>

        <template slot="no-data">
          <div class="text-xs-center" v-if="fetching_data">
            <h3>Loading data, wait a moment ...</h3>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      saving_price: false,
      fetching_data: false,
      price_per_round: null,
      round_distance: null,
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "num",
        },
        { text: "Price", align: "center", value: "price", sortable: false },
        {
          text: "Distance",
          align: "center",
          value: "end",
          sortable: false,
        },
        {
          text: "Start date",
          align: "center",
          value: "start",
          sortable: false,
        },
        { text: "End date", align: "center", value: "end", sortable: false },
      ],
      price: [
        {
          num: 1,
          start: "30/10/19",
          end: "Present",
          price: 30,
        },
        {
          num: 2,
          start: "30/09/19",
          end: "30/10/19",
          price: 40,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      free_price_per_round_list: "fetchCashRider/getFreePricePerRoundList",
      isEditPriceRound: "isEditPriceRound",
    }),
  },
  methods: {
    async save() {
      if (this.$refs.form.validate()) {
        this.saving_price = true;
        let form = {
          round_price: parseFloat(this.price_per_round),
          round_distance: parseFloat(this.round_distance),
        };
        let check = await this.$store.dispatch(
          "fetchCashRider/saveFreePricePerRound",
          form
        );
        if (check == true) {
          this.price_per_round = 0;
        }
        this.saving_price = false;
      }
    },
    async fetchData() {
      this.fetching_data = true;
      await this.$store.dispatch("fetchCashRider/getFreePricePerRound");
      this.fetching_data = false;
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },

      {
        text: "Set price/round",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style>
.v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 3px;
}
</style>

<style scoped>
.text-bold {
  font-size: 14px;
  font-weight: bold;
}
</style>

